export default __webpack_public_path__ + "static/media/logo_eurowindow.7994d3f5.png";